import React from "react";
import { Grid, Box } from "@mui/material";
import "./mapData.scss";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/validation/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
// import MapDataTable from "../../../components/MapDataTable/TemplateDriven/MapDataTable";
// import CNCTableWrapper from "../../../components/MapDataTable/Free-Form/CNCTableWrapper";
import ImageViewer from "./ImageViewer";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import MapDataTable from "../../../components/MapDataTable/TemplateDriven/MapDataTable";
// import QCTable from "../../../components/MapDataTable/QCTable/QCTable";

class MapData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      selectedFile: {
        tagName: "",
        fileNo: 0, // index is considered as file
        pageNo: 0,
      },
      // batch_for_qc: localStorage.getItem("batch_for_qc"),
    };
  }

  handleCloseModal = () => {
    this.setState({
      openRejectionModal: false,
    });
  };

  handleReject = (remark) => {
    this.props?.child.current.mapData("reject", remark);
    this.setState({
      openRejectionModal: false,
    });
  };

  render() {
    return (
      <div>
        {this.props?.coorData && this.props?.coorData?.length ? (
          <Box className="img-viewer">
            <Grid container spacing={1}>
              {this?.props?.hideScreen ? (
                <Grid xs={this?.props?.leftgrid} item>
                  <ImageViewer
                    // isFullView={this?.props?.isFullView}
                    {...this.props}
                    role="investigatorValidatior"
                  />
                </Grid>
              ) : (
                <></>
              )}
              <Grid xs={this?.props?.rightgrid} item>
                <Box className="container-1">
                  {/* {this?.state?.batch_for_qc === "false" ? (
                    this.props?.is_template_uploaded === true ? ( */}
                  <MapDataTable
                    selectedFile={this.state?.selectedFile}
                    areaIndex={this.state?.areaIndex}
                    parametersData={
                      this.props.isPreviewOnly
                        ? this.props?.parametersDataFromChildByRefToViewonly
                        : this.props?.parametersData
                    }
                    ref={this.props?.child}
                    // isFullView={this?.props?.isFullView}
                    role={"investigatorValidatior"}
                    reProcess={this.props.reProcess}
                    reValidateInvestigatorValidator={
                      this.props.reValidateInvestigatorValidator
                    }
                    showContextMenu={false}
                    showParameterTable={true}
                    forValue={this.props.forValue}
                  />
                  {/* ) : this.props?.is_template_uploaded === false ? (
                      <CNCTableWrapper
                        selectedFile={this.state?.selectedFile}
                        ref={this.props?.child}
                        role={localStorage.userRole}
                        parametersData={this.props?.parametersData}
                        columnsCount={this.props?.columnsCount}
                        reProcess={this.props?.reProcess}
                        reValidateInvestigatorValidator={this.props?.reValidateInvestigatorValidator}
                        showContextMenu={false}
                        isDisableOnChangeInput={true}
                        isDisableOnBlur={true}
                        showParameterTable={true}
                        // isFullView={this?.props?.isFullView}
                      />
                    ) : (
                      <TableSkeleton />
                    )
                  ) : (
                    <QCTable
                      role="validator"
                      selectedFile={this.state?.selectedFile}
                      qcTemplateData={this?.props?.qcTemplateData || []}
                      ref={this.props?.qcChild}
                      showParameterTable={false}
                      // assignToValidator={this.props?.assignToValidator}
                      // isFullView={this?.props?.isFullView}
                    />
                  )} */}
                </Box>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid container spacing={1}>
            <Grid item xs={this?.props?.leftgrid}>
              <TableSkeleton />
            </Grid>
            <Grid item xs={this?.props?.rightgrid}>
              <TableSkeleton />
            </Grid>
          </Grid>
        )}

        {this.state.openRejectionModal && (
          <ModalProcessor
            modalOpen={this.state.openRejectionModal}
            handleClose={this.handleCloseModal}
            handleReject={this.handleReject}
            isShowClearButton={false}
            disableDeleteRejection={true}
            isShowDeleteButton={false}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.validation?.coorData?.coordinatesDetails || [],
    parametersData:
      state.validation?.coorData?.mapping_details?.parametersData || [],
    is_template_uploaded: state.validation?.coorData?.is_template_uploaded,
    apiStatus: state.validation?.apiStatus,
    columnsCount: state.validation?.coorData?.mapping_details?.columnsCount,
    reProcess: state.validation?.coorData?.mapping_details?.reProcess,
    reValidateInvestigatorValidator:
      state.validation?.coorData?.mapping_details
        ?.reValidateInvestigatorValidator,
    validatorRowRejectionData:
      state.validation?.coorData?.mapping_details?.validatorRowRejectionData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapData);
